import React from 'react';
import {injectStripe, CardElement} from 'react-stripe-elements';
import mastercard from '../static/images/mastercard.png';
import visa from '../static/images/visa.png';
import ideal from '../static/images/ideal.png';
import sofort from '../static/images/sofort.png';
import Api from '../services/api';
import AuthService from '../services/auth';
import { map } from 'lodash';
import config from '../config';
import sofortCountries from '../constants/sofort-countries';
import idealCountries from '../constants/ideal-countries';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';

class StripeForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      chosenMethod: 'card',
    };
  }

  handlePayment(type, price) {
    const { stripe, ucdUser, transactionType, product, showOverlay } = this.props;
    showOverlay();
    let args = {
      type,
      amount: parseInt(price * 100, 10),
      currency: 'eur',
      redirect: {
        return_url: config.stripeConfig.returnUrl,
      },
      metadata: {
        type: transactionType,
      },
    };

    if(type === 'sofort') {
      const countries = map(ucdUser.locations,'country');
      let sofortCountry = false;
      countries.map(country => {
        if(!sofortCountry && sofortCountries.includes(country)) {
          sofortCountry = country;
        }
        return country;
      });
      args['sofort'] = {country: sofortCountry};
    }

    stripe.createSource(args).then((result) => {
      (new Api()).post('/payment/create', {
        sourceId: result.source.id,
        amount: price,
        product,
        method: `stripe - ${type}`,
        transactionType,
      }, AuthService.getAuthCookie())
        .then(() => {
          window.location = result.source.redirect.url;
        });
    });
  }

  handleSubmit(ev) {
    const { stripe, ucdUser, transactionType, price, product, refCode, showOverlay } = this.props;
    showOverlay();
    // We don't want to let default form submission happen here, which would refresh the page.
    ev.preventDefault();

    // Within the context of `Elements`, this call to createToken knows which Element to
    // tokenize, since there's only one in this group.
    stripe.createToken({name: `${ucdUser.firstName} ${ucdUser.lastName}`}).then(({token}) => {
      (new Api()).post('/payment/create', {
        sourceId: token,
        amount: price,
        product,
        refCode: refCode,
        method: 'stripe',
        transactionType,
      }, AuthService.getAuthCookie())
        .then(response => {
          if(response.redirect) {
            this.props.history.push(response.redirect);
          }
        });
    });


    // However, this line of code will do the same thing:
    // this.props.stripe.createToken({type: 'card', name: 'Jenny Rosen'});
  }

  handleMethodChange(method) {
    this.setState({
      chosenMethod: method,
    });
  }

  render() {
    const { chosenMethod } = this.state;
    const { price, ucdUser } = this.props;
    const countries = map(ucdUser.locations,'country');
    let showSofort = false;
    let showIdeal = false;
    countries.map(country => {
      if(sofortCountries.includes(country)) {
        showSofort = true;
      }
      if(idealCountries.includes(country)) {
        showIdeal = true;
      }
      return country;
    });
    return (
      <div className="col col-12 ">
        <div className="stripe-title">
          Choose your payment method
        </div>
        <div className="row">
          <div className="col">
            <label htmlFor="card" className={`method-label ${(chosenMethod === 'card')?'active':''}`} >
              <img src={visa} alt={'visa'} />
              <img src={mastercard} alt={'mastercard'} />
              <input id="card" checked={chosenMethod === 'card'} onChange={() => {this.handleMethodChange('card')}} type="radio" name="chosenMethod" value="card" />
            </label>
          </div>
          {showIdeal && <div className="col">
            <label htmlFor="ideal" className={`method-label ${(chosenMethod === 'ideal')?'active':''}`} >
              <img src={ideal} alt={'ideal'} />
              <input id="ideal" checked={chosenMethod === 'ideal'} onChange={() => {this.handleMethodChange('ideal')}} type="radio" name="chosenMethod" value="ideal" />
            </label>
          </div>}
          {showSofort && <div className="col">
            <label htmlFor="sofort" className={`method-label ${(chosenMethod === 'sofort')?'active':''}`} >
              <img src={sofort}  alt={'sofort'}/>
              <input id="sofort" checked={chosenMethod === 'sofort'} onChange={() => {this.handleMethodChange('sofort')}} type="radio" name="chosenMethod" value="sofort" />
            </label>
          </div>}
        </div>
        <div className="row button-row">
          <div className="col col-12 method-container">
            {chosenMethod === 'card' &&
            <form onSubmit={(e) => this.handleSubmit(e)}>
              <label className={'stripe-label'}>
                Card details
                <CardElement
                  onReady={(el) => el.focus()}
                />
              </label>
              <button className="method-form__button">
                Pay &#36;{price.toFixed(2)}
              </button>
            </form>}
            {chosenMethod !== 'card' &&
            <div className="method-form__button"
              onClick={() => {this.handlePayment(chosenMethod, price)}}
            >
              Pay &#36;{price.toFixed(2)}
            </div>}
          </div>
        </div>
      </div>
    );
  }
}

export default compose(injectStripe,
  withRouter)(StripeForm);


// WEBPACK FOOTER //
// ./src/components/StripeForm.js